import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CtaBanner() {
  const navigate = useNavigate();
  const today = new Date();
  today.setDate(today.getDate() + 7);
  const date = today.toISOString().split('T')[0];

  return (
    <section className="relative bg-[#080c1a] py-20 sm:py-28 px-4 overflow-hidden">
      {/* Background blobs — responsive sizes to prevent overflow */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-20%] left-[10%] w-48 h-48 sm:w-72 sm:h-72 lg:w-[400px] lg:h-[400px] bg-violet-700 opacity-20 rounded-full blur-[80px] sm:blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[5%] w-40 h-40 sm:w-64 sm:h-64 lg:w-[350px] lg:h-[350px] bg-orange-600 opacity-15 rounded-full blur-[60px] sm:blur-[100px]" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center text-white">
        <span className="inline-block bg-white/5 border border-white/10 text-orange-300 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-5 sm:mb-6">
          Start Saving Today
        </span>
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-4 sm:mb-6">
          Your Next Adventure
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-pink-400">
            Starts Here
          </span>
        </h2>
        <p className="text-slate-400 text-base sm:text-lg mb-8 sm:mb-10 max-w-xl mx-auto">
          Thousands of flights. Unbeatable prices. Book your perfect trip in one click.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <button
            onClick={() => navigate(`/flights?origin=JFK&destination=LAX&date=${date}&passengers=1&class=economy`)}
            className="bg-gradient-to-r from-orange-500 to-pink-600 hover:from-orange-400 hover:to-pink-500 text-white font-bold px-8 sm:px-10 py-3.5 sm:py-4 rounded-2xl text-sm sm:text-base transition-all shadow-2xl shadow-orange-500/20 hover:-translate-y-0.5 w-full sm:w-auto"
          >
            ✈️ Search Flights Now
          </button>
          <button
            onClick={() => navigate('/my-bookings')}
            className="bg-white/5 border border-white/15 hover:bg-white/10 text-white font-semibold px-8 sm:px-10 py-3.5 sm:py-4 rounded-2xl text-sm sm:text-base transition-all w-full sm:w-auto"
          >
            📋 Manage My Booking
          </button>
        </div>

        {/* Airline list */}
        <div className="mt-12 sm:mt-16 pt-8 sm:pt-10 border-t border-white/5">
          <p className="text-slate-600 text-xs uppercase tracking-widest mb-4 sm:mb-5">Flights from all major US airlines</p>
          <div className="flex flex-wrap justify-center gap-x-5 sm:gap-x-8 gap-y-3">
            {['Delta', 'American', 'United', 'Southwest', 'JetBlue', 'Alaska', 'Spirit', 'Frontier'].map(a => (
              <span key={a} className="text-slate-600 text-xs sm:text-sm font-semibold hover:text-slate-400 transition-colors cursor-default">
                {a}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
